"use client";

import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useDebounce } from "use-debounce";
import { TASK_ROW_HEIGHT } from "@/common/constants";
import { Command, CommandEmpty, CommandGroup, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { orbitSupportProjectQueryOptions } from "@/queries/queries";
import { CustomCommandInput } from "./CommandMenu";

type OrbitSupportProject = {
    id: string;
    name: string;
    clientName: string;
};

interface OrbitSupportProjectSelectProps {
    value: OrbitSupportProject | null;
    onChange: (values: OrbitSupportProject | null) => void;
}

export function OrbitSupportProjectSelect({ value, onChange }: OrbitSupportProjectSelectProps) {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const [debouncedSearch] = useDebounce(search, 300);
    const { data: projects, isLoading } = useQuery(orbitSupportProjectQueryOptions(debouncedSearch));

    const valueId = (value?.id || "").toString();

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger render={trigger(<div className={cn("truncate")}>{value?.name}</div>, value)} />
            <PopoverContent sideOffset={-TASK_ROW_HEIGHT} align="start" className="w-full p-0 max-w-[400px]">
                <Command shouldFilter={false} value={valueId}>
                    <CustomCommandInput isLoading={isLoading} placeholder="Search projects..." value={search} onValueChange={setSearch} />
                    <CommandEmpty>No projects found</CommandEmpty>
                    <CommandList>
                        <CommandGroup>
                            {projects?.map((project) => {
                                return (
                                    <CommandItem
                                        value={project.id}
                                        key={project.id}
                                        // onClick={(e) => e.stopPropagation()}
                                        className="flex flex-col items-start"
                                        onSelect={() => {
                                            onChange(project);
                                            setOpen(false);
                                        }}
                                    >
                                        <div className="leading-tight truncate w-full">{project.name}</div>
                                        <div className="leading-1 pb-1.5 text-[11px] text-orsane-muted">{project.clientName}</div>
                                    </CommandItem>
                                );
                            })}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
}
